export default "__VITE_ASSET__GBD5jLKG__"